<template>
  <div>
    <Container>
      <TopBar />
      <div class="page">
        <div v-if='orderAddress.id'>
          <div class='addressTitle'>
              <b>收貨地址(Delivery Address)</b>
            </div>
            <div class='address transition_dom'>
                <div class="item">
                  <div class="left">
                    <span class="name">{{orderAddress.name}}</span>
                    <span class="tel">{{orderAddress.moblie_phone}}</span>
                    <Tag v-if="orderAddress.is_default" class="addressTag" color="#B176C5">帳戶預設地址&nbsp;&nbsp;Default Address</Tag>
                    <p>
                      <!-- <i v-if='IconText(orderAddress.tag_type)' :style="{color: iconColor(orderAddress.tag_type)}" v-text='IconText(orderAddress.tag_type)'></i> -->
                      {{orderAddress.province || orderAddress.region}}&nbsp;&nbsp;{{orderAddress.city}}&nbsp;&nbsp;{{orderAddress.street}}&nbsp;&nbsp;{{orderAddress.street2}}&nbsp;&nbsp;
                    </p>
                  </div>
                  <div class="right" v-if='canEditAddress'>
                    <img title="編輯地址" src="@/assets/edit.png" v-on:click.stop='modifyOrderAddress(orderAddress)'>
                  </div>
                </div>
            </div>
          </div>
        <template v-if='canEditAddress'>
          <!-- 地址標題 -->
        <div class='addressTitle' v-if='getVipNo'>
          <b>選擇合併發貨地址(Address for Group Deliery)</b>
          <Button class='addAddress' type="primary" @click='showAddressList = true' ghost>選擇合併發貨地址 Select Group Deliery Address</Button>
        </div>
        <template v-if='showAddressList'>
          <!-- 地址 -->
          <div id='Anchor_props' class='address transition_dom' v-if='getVipNo'>
            <template v-for='(address,index) in sortaddresse'>
              <div class="item" v-show='!isAllAddress?index<=3:true' :saa='index' :key="address.id" :class='{select:(address.id==selectAddress.id),hover:(address.id==hoverActive)}' v-on:click.stop='chooseAddress(address)' @mouseenter='hoverActive=address.id' @mouseleave="hoverActive=-1">
                <div class="left">
                  <span class="name">{{address.name}}</span>
                  <span class="tel">{{address.moblie_phone}}</span>
                  <Tag v-if="address.is_default" class="addressTag" color="#B176C5">帳戶預設地址&nbsp;&nbsp;Default Address</Tag>
                  <p>
                    <!-- <i v-if='IconText(address.tag_type)' :style="{color: iconColor(address.tag_type)}" v-text='IconText(address.tag_type)'></i> -->
                    {{address.province}}&nbsp;&nbsp;{{address.city}}&nbsp;&nbsp;{{address.street}}&nbsp;&nbsp;{{address.street2}}&nbsp;&nbsp;
                  </p>
                </div>
                <div class="right" v-show='address.id==hoverActive' v-if="!isMobile">
                  <!-- <Icon type="ios-paper-outline" size='20' color='#B176C5' /> &nbsp;
                                  <Icon type="ios-trash-outline" size='20' color='#B176C5' /> -->
                  <img title="編輯地址" src="@/assets/edit.png" v-on:click.stop='modifyAddress(address)'>
                  &nbsp;
                  <img title="刪除地址" src="@/assets/del.png" v-on:click.stop='deleteAddress(address)'>
                </div>
                <div class="right" v-if="isMobile">
                  <!-- <Icon type="ios-paper-outline" size='20' color='#B176C5' /> &nbsp;
                                  <Icon type="ios-trash-outline" size='20' color='#B176C5' /> -->
                  <img title="編輯地址" src="@/assets/edit.png" v-on:click.stop='modifyAddress(address)'>
                  &nbsp;
                  <img title="刪除地址" src="@/assets/del.png" v-on:click.stop='deleteAddress(address)'>
                </div>
              </div>
            </template>
          </div>
          <Button class='addAddress' type="primary" @click='addAddress' ghost>新增收貨地址(Add New Delivery Address)</Button>
          <span v-if='addresses.length > 4' class="showAllAddr" @click='operating'>{{isAllAddress?'收起地址':'顯示全部地址'}}&nbsp;<b>&gt;</b></span>
        </template>
                
        </template>
        <!-- 待合併訂單 -->
        <div class='addressTitle'><b>訂單信息 Order Summary</b></div>
        <Table class='orderTable' stripe :columns="columns" :data="orders"></Table>
        <div class='xs-cells' v-for='order in orders'>
            <Row class='xs-cells-item' style='margin-top: 0.2rem;'>
              <Col span='12'>訂單日期(Order Date)</Col>
              <Col span='12' style='text-align: center;' v-if="order.CreateTime">{{order.CreateTime.substr(0,19).replace('T',' ')}}</Col>
            </Row>
            <Row class='xs-cells-item' style='margin-top: 0.2rem;'>
              <Col span='12'>訂單編號(Order Number)</Col>
              <Col span='12' style='text-align: center;'>{{order.OrderNo}}</Col>
            </Row>
            <Row class='xs-cells-item' style='margin-top: 0.2rem;'>
              <Col span='12'>訂單金額/PV(Order Amount/PV)</Col>
              <Col span='12' style='text-align: center;'>{{order.TotalPaid}} / {{order.PValue}}</Col>
            </Row>
            <Row class='xs-cells-item' style='margin-top: 0.2rem;'>
              <Col span='12'>訂單渠道(Order Channel)</Col>
              <Col span='12' style='text-align: center;'>{{order.Channel}}</Col>
            </Row>
            <Row class='xs-cells-item' style='margin-top: 0.2rem;'>
              <Col span='12'>訂單狀態(Order Status)</Col>
              <Col span='12' style='text-align: center;'>{{typePlay(order)}}</Col>
            </Row>
            <Row class='xs-cells-item' style='margin-top: 0.2rem;'>
              <Col span='12' push='12' style='text-align: center;'><Button style='color:#B176C5;' type='text' @click='showDetail(order)'>查看</Button></Col>
            </Row>
          </div>
        <!-- <div v-if='!OCNo' class="tip">{{needPayFee ?'您的訂單不滿足免運費條件，需要支付HK$30運費':'您的訂單已滿足免運費條件，無需再單獨支付運費'}}</div> -->
        <div style='margin:auto;text-align: center;margin-top: 0.4rem;'>
          <Button :loading='confirming' v-if='canEditAddress' type='primary' size='large' @click='confirmMerge()'>{{OCNo ? '修改地址(Edit address)':'合併發貨(Combined shipment)'}}</Button>
          <!-- <Button :loading='confirming' v-if='canEditAddress' type='primary' size='large' @click='confirmMerge()'>{{OCNo ? '修改地址(Edit address)':(needPayFee ? '去支付(To pay)':'完成(Accomplish)')}}</Button> -->
        </div>
      </div>
      <editAddressView :title="editAddress.id>0?'編輯地址(Edit address)':'新增地址(New address)'" :editAddress='editAddress' :show='show' @confirm='editConfirm' @cancel='show=false' :loading='loading'></editAddressView>
    </Container>
  </div>
</template>
<script>
import TopBar from "@/components/common/TopBar";
import editAddressView from "@/components/order/editAddressView";
import {
  mapState,
  mapMutations,
  mapActions,
  mapGetters
} from 'vuex'
import {
  systemConfigMethods,
  cartInfoMethods,
  userInfoOrderMethods,
  promoCodeMethods,
  addressMethods,
  promoteMethods,
  productLimtMethods,
  getImgPath,
} from "@/components/common/mixin";
export default {
  data() {
    return {
      showAddressList:false,
      isAllAddress: false,
      hoverActive: -1,
      OCNo:undefined,
      confirming:false,
      columns: [{
          key: "CreateTime",
          renderHeader: (h, index) => {
            return h("div", [
              h("div", null, "訂單日期"),
              h("div", null, "Order Date")
            ]);
          },
          render: (h, params) => {
            let innerHtml = params.row.CreateTime.substr(
              0,
              19
            ).replace("T", " ");
            return h("div", null, innerHtml);
          }
        },
        {
          key: "OrderNo",
          renderHeader: (h, index) => {
            return h("div", [
              h("div", null, "訂單編號"),
              h("div", null, "Order Number")
            ]);
          },
        },
        {
          key: "total",
          renderHeader: (h, index) => {
            return h("div", [
              h("div", null, "訂單金額/PV"),
              h("div", null, "Order Amount/PV")
            ]);
          },
          render: (h, params) => {
            let innerHtml = `HK$${params.row.TotalPaid} / ${params.row.PValue}`;
            return h("div", null, innerHtml);
          }
        },
        {
          key: "Channel",
          renderHeader: (h, index) => {
            return h("div", [
              h("div", null, "訂單渠道"),
              h("div", null, "Order Channel")
            ]);
          }
        }, {
          key: "OrderStatus",
          // width: 300,
          renderHeader: (h, index) => {
            return h("div", [
              h("div", null, "訂單狀態"),
              h("div", null, "Order Status")
            ]);
          },
          render: (h, params) => {
            let innerHtml = this.typePlay(params.row);
            return h("div",null,innerHtml)
          }
        }, {
          key: "Detail",
          // width: 300,
          renderHeader: (h, index) => {
            return h("div", [
              h("div", null, "明細"),
              h("div", null, "Detail")
            ]);
          },
          render: (h, params) => {
            var btnList = [];
                btnList.push(
              h(
                "a",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    // marginRight: '5px',
                    // width:'150px'
                    display: "block",
                    color: "#B176C5",
                    fontSize: "0.13rem"
                  },
                  on: {
                    click: () => {
                      this.showDetail(params.row);
                    }
                  }
                },
                "    明細(Detailed)    "
              )
            );
            return h("div", btnList);
          }
        }
      ],
      orders: [],
      selectAddress:{},
      orderAddress:{},
      confirmTime:null,
    }
  },
  created() {
    this.$nextTick(function() {
      this.initData()
    })
  },
  mounted() {

  },
  watch: {

  },
  mixins: [addressMethods],
  components: {
    TopBar,
    editAddressView,
  },
  computed: {
    ...mapGetters(["bogo_switch_tip", "getAccessToken", "getVipNo"]),
    ...mapState({
      userInfo: (state) => state.common.wechatUserInfo,
    }),
    sortaddresse() {
      return this.addresses.sort(function(a, b) {
        return b.is_default - a.is_default;
      });
    },
    needPayFee(){
      if (this.orders[0]) {
        return this.orders[0].ExpressFee > 0
      }
      return true
    },
    canEditAddress(){
      let now = new Date()
      let limit = new Date(2031,6,25,16,0);
      if(now < limit){
        return true;
      }
      // if (!this.confirmTime) {
      //   return true
      // }
      // if (now - this.confirmTime < 1800000) {
      //   return true
      // }
      return false
    },
		isMobile() {
			if (document.body.clientWidth <= 768) {
				return true;
			}
			return false;
		},
  },
  methods: {
    ...mapMutations(["SET_ORDERNN",'SAVE_ORDER']),
    ...mapActions([
      "postAddAddressAction",
      "delAddressAction",
      'getWechatUserInfoAction',
      'getMergeOrdersAction',
      'mergeOrdersAction',
      'getOrderEncryptionAction',
    ]),
    modifyOrderAddress(address){
      this.modifyAddress(address)
    },
    async editConfirm(address) {
      await this.asyncOK(address)
      if (this.orderAddress && this.orderAddress.id) {
        this.orderAddress = this.addresses.filter(item=>item.id == this.orderAddress.id)[0]
        this.selectAddress = this.orderAddress
      }
    },
    async initData() {
      this.addresses = this.userInfo.value && (this.userInfo.value.binding.address || []);
      let oc = this.$route.query.no;
      this.OCNo = oc;
      let response = await this.getMergeOrdersAction(oc)
      console.log(response)
      if (response.OrderList) {
        this.orders = response.OrderList
        this.orderAddress =  response.Address[0]
        this.confirmTime = Date.fromStr(response.ConfirmTime)
      } else {
        this.orders = response
      }
    },
    chooseAddress(address){
      this.selectAddress = address
    },
    operating() {
      this.isAllAddress = !this.isAllAddress;
    },
    showDetail(order) {
      this.SAVE_ORDER(order);
      this.$router.push(
        `/order/detail?orderNo=${order.OrderNo}&channel=${order.Channel}`
      );
    },
    async confirmMerge(){
      if (!this.selectAddress.province_id) {
        this.$Toast.show('請選擇收貨地址', { duration: 1500 });
        return
      }
      let OCNo = this.$route.query && this.$route.query.no
      this.confirming = true
      let response = await this.mergeOrdersAction({
        Address:this.selectAddress,
        OCNo,
      })
      this.confirming = false
      if (OCNo) {
        if (response == 1) {
          this.$Modal.success({
            title:'結果',
            content:`地址修改成功,點擊前往我的訂單<br>Address Updated. Please click "confirm" to go to My Order`,
            okText: '確定 CONFIRM',
            onOk:()=>{
              this.$router.replace('/order/orders')
            }
          })
        } else {
          this.$Modal.error({
            title:'結果',
            content:'地址修改失敗,請稍後重試',
          })
        }
        return
      }
      if (!response[0]) return 
      let order = response[0]
      if (order.ExpressFee == 0) {
        this.$Modal.success({
          title:'結果',
          content:'訂單合併成功,點擊前往我的訂單',
          onOk:()=>{
            this.$router.replace('/order/orders')
          }
        })
        return
      }
      let os = order.orderNo //原始訂單號
      let orderno = await this.getOrderEncryptionAction(os);
      if (orderno) {
        this.SET_ORDERNN({
          orderno,
          os
        });
        this.$router.push({
            path: "/order/payment",
            query: {
                orderno,
                os
            }
        });
      }
    },
    typePlay(item) {
      if (item.OrderStatus == 'Pay') {
        return '待合併發貨'
      } else if (item.OrderStatus == 'Confirm') {
        return '已合併發貨'
      }
	},
  },
}

</script>
<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";

.page {
  width: 78.03vw;
  margin: 40px auto;
  margin-bottom: 30px;
  overflow: hidden;
}

.addressTitle {
  margin-top: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  line-height: 30px;

  b {
    @include fontSize($font-size-16);
  }

  .addAddress {
    float: right;
    @include fontSize($font-size-14);
    border-radius: 0;
  }
}

.addressTag {
  @include fontSize($font-size-14);
}

.address {
  @include fontSize($font-size-15);
  overflow: hidden;

  .item {
    cursor: pointer;
    width: 100%;
    border: 1px solid #eee;
    padding: 20px;
    overflow: hidden;
    margin-bottom: 15px;

    &.select {
      border-color: $theme-color;
      border-width: 2px;

      &.hover {
        border-width: 2px;
      }
    }

    &.hover {
      border-color: $theme-color;
      border-width: 1px;
    }

    .left {
      float: left;

      i {
        display: inline-block;
        font-style: normal;
        @include fontSize($font-size-13);
        color: #fff;
        margin-right: 3px;
      }
    }

    .right {
      float: right;
      position: relative;
      top: 20px;

      img {
        width: 15px;
      }
    }

    .name {}

    .tel {
      margin-left: 20px;
      margin-right: 10px;
    }

    p {
      padding-top: 3px;
    }
  }
}

.showAllAddr {
  color: $theme-color;
  font-weight: 500;
  border-bottom: 1px solid #fff;
  display: block;
  cursor: pointer;
  @include fontSize($font-size-14);
  // margin-bottom: 20px;
}
.tip {
  margin-top: 0.1rem;
  color: $theme-color;
  @include fontSize($font-size-14);
}
.xs-cells {
  display:none;
}
@media (max-width: 768px){
  .orderTable {
    display:none;
  }
  .xs-cells {
    display:block;
  }
}
</style>